import clsx from 'clsx';
import { observer } from 'mobx-react';
import { Avatar } from '../Avatar';
import { NotTranslated, translation, TranslationsContext } from '../Translations';
import Image from './Image';

interface Props {
  avatar: Avatar;
}

function ParticipantAvatar({ avatar }: Props) {
  switch (avatar.kind) {
    case 'avatar-link':
      return (
        <TranslationsContext.Consumer>
          {(ts) => <Image src={avatar.link.href} alt={translation('User Photo')(ts)} style="" />}
        </TranslationsContext.Consumer>
      );
    case 'avatar-initials':
      return (
        <span
          className={clsx(
            'bg-black text-white text-center font-bold rounded-full min-h-full min-w-full',
            'max-w-full max-h-full block leading-8',
          )}
        >
          <NotTranslated text={avatar.initials} />
        </span>
      );
  }
}

export default observer(ParticipantAvatar);
